import { Container, DeleteButton, History, HistoryItem, LinkContainer, NewConversation, Overlay } from "./styles";
import nossoTimeIcon from "../../assets/icons/nosso-time.svg";
import loginIcon from "../../assets/icons/login-icon.svg";
import tutorialIcon from "../../assets/icons/tutorial.svg";
import trashIcon from "../../assets/icons/trash.svg";
import plusIcon from "../../assets/icons/plus.svg";
import exclamationIcon from "../../assets/icons/exclamation.svg";
import peopleIcon from "../../assets/icons/people-talk.svg";
import bookIcon from "../../assets/icons/book.svg";
import lockerIcon from "../../assets/icons/locker.svg";
import homeIcon from "../../assets/icons/home.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Conversation, loadHistory } from "../../utils/conversationStorage";

interface SidebarProps {
    open: boolean;
    onClose: () => void;
    onSelectConversation?: (conv: Conversation) => void;
    onDeleteConversation?: (id: string) => void;
    onNewConversation?: () => void;
    onOpenTutorial?: () => void;
    activeConversationId?: string;
    activeTab?: string;
    setActiveTab?: (tab: string) => void;
    setActiveChat?: (bool : boolean) => void;
}

export function Sidebar({ open, onClose, onSelectConversation, onDeleteConversation, onNewConversation, onOpenTutorial, activeConversationId, activeTab, setActiveTab, setActiveChat}: SidebarProps) {    const location = useLocation();
    const nav = useNavigate();
    const [history, setHistory] = useState<Conversation[]>([]);

    useEffect(() => {
        if (open) {
            setHistory(loadHistory());
        }
    }, [open]);

    if (!open) return null;

    function handleSelectConversation(conv: Conversation) {
        onSelectConversation?.(conv);
    }

    function handleDeleteConversation(e: React.MouseEvent | React.KeyboardEvent, conv: Conversation) {
        e.stopPropagation();
        onDeleteConversation?.(conv.id);
        setHistory((prev) => prev.filter((c) => c.id !== conv.id));
    }

    function handleDeleteKey(e: React.KeyboardEvent<HTMLDivElement>, conv: Conversation) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleDeleteConversation(e, conv);
        }
    }

    function handleNewConversation() {
        onNewConversation?.();
    }

    function handleNewConversationKey(e: React.KeyboardEvent<HTMLDivElement>) {
        if (e.key === 'Enter' || e.key === ' ') {
            handleNewConversation();
        }
    }

    function handleNavKey(e: React.KeyboardEvent<HTMLDivElement>, path: string) {
        if (e.key === 'Enter' || e.key === ' ') {
            nav(path);
        }
    }

    function handleTabKey(e: React.KeyboardEvent<HTMLDivElement>, tab: string) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setActiveTab?.(tab);
        onClose();
    }
}

    return (
        <>
            <Overlay onClick={onClose} />
            <Container>
                {activeTab === "home" && (
                    <>
                        <LinkContainer $active={false} onClick={() => (setActiveChat?.(false), onOpenTutorial?.())} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onOpenTutorial?.(); }} tabIndex={5}>
                            <img src={exclamationIcon} alt="Tutorial" />
                            <h1>Tutorial</h1>
                        </LinkContainer>
                    </>
                )}
                {/* {activeTab === "home" || activeTab === "glossary" || activeTab === "attendance"  ? (
                    <>
                        {activeTab === "home" && 
                        <LinkContainer $active={false} onClick={() => (setActiveChat?.(false), onOpenTutorial?.())} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onOpenTutorial?.(); }} tabIndex={5}>
                            <img src={exclamationIcon} alt="Tutorial" />
                            <h1>Tutorial</h1>
                        </LinkContainer>}
                        
                        <LinkContainer $active={activeTab === "attendance"} onClick={() => { setActiveTab?.("attendance"); onClose(); }} onKeyDown={(e) => handleTabKey(e, "attendance")} tabIndex={3}>
                            <img src={peopleIcon} alt="Atendimento" />
                            <h1>Atendimento</h1>
                        </LinkContainer>
                        <LinkContainer $active={activeTab === "glossary"} onClick={() => { setActiveTab?.("glossary"); onClose(); }} onKeyDown={(e) => handleTabKey(e, "glossary")} tabIndex={3}>
                            <img src={bookIcon} alt="Glossário" />
                            <h1>Glossário</h1>
                        </LinkContainer>
                    </>
                ) : (
                    <LinkContainer $active={false} onClick={() => { nav("/home"); onClose(); }} onKeyDown={(e) => handleTabKey(e, "home")} tabIndex={3}>
                        <img src={homeIcon} alt="Home" />
                        <h1>Início</h1>
                    </LinkContainer>
                )}
                <LinkContainer $active={location.pathname === "/login"} onClick={() => nav("/login")} onKeyDown={(e) => handleNavKey(e, "/login")} tabIndex={4}>
                    <img src={lockerIcon} alt="Login" />
                    <h1>Área Restrita</h1>
                </LinkContainer>
                <LinkContainer $active={location.pathname === "/time"} onClick={() => nav("/time")} onKeyDown={(e) => handleNavKey(e, "/time")} tabIndex={3}>
                    <img src={nossoTimeIcon} alt="Nosso Time" />
                    <h1>Quem contribuiu</h1>
                </LinkContainer> */}
                {activeTab === "home" && (
                    <History>
                        <h1>Recentes</h1>
                        <NewConversation
                            tabIndex={6}
                            role="button"
                            onClick={handleNewConversation}
                            onKeyDown={handleNewConversationKey}
                        >
                            <img src={plusIcon} alt="" />
                            <h2>Nova conversa</h2>
                        </NewConversation>
                        <div className="historyTitles">
                            {history.length === 0 ? (
                                <h2 style={{ textAlign: "center" }}>Nenhuma conversa</h2>
                            ) : (
                                history.map((conv) => (
                                    <HistoryItem key={conv.id}>
                                        <h2
                                            tabIndex={6}
                                            onClick={() => handleSelectConversation(conv)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    handleSelectConversation(conv);
                                                }
                                            }}
                                            className={conv.id === activeConversationId ? "active" : ""}
                                        >
                                            {conv.title}
                                        </h2>
                                        <DeleteButton
                                            className="hint"
                                            data-hint="Excluir"
                                            data-hint-placement="top"
                                            role="button"
                                            tabIndex={6}
                                            onClick={(e) => handleDeleteConversation(e, conv)}
                                            
                                        >
                                            <img src={trashIcon} alt="Excluir conversa" />
                                        </DeleteButton>
                                    </HistoryItem>
                                ))
                            )}
                        </div>

                    </History>
                )}
            </Container>
        </>
    );
}